<template>
<v-card elevation="8" outlined rounded="lg" class="buscador-modal">
    <v-card-title class="justify-center py-3" style="background-color: #002245; color: white">
      <h4 class="font-weight-bold">{{ title }}</h4>
    </v-card-title>
    <v-card-text>
    <v-row class="mt-2" align="center">
        <v-col cols="12" md="2">
            <v-text-field outlined dense class="textfield-cuadrado" type="" v-model="uniest" label="UNICODIGO" @keyup.enter="buscarEstudiante()">
            </v-text-field>
        </v-col>
        <v-col cols="12" md="2">
            <v-text-field outlined dense class="textfield-cuadrado" type="text" v-model="pat" label="PATERNO" @input="pat = pat.toUpperCase()" @keyup.enter="buscarEstudiante()">
            </v-text-field>
        </v-col>

        <v-col cols="12" md="2">
            <v-text-field outlined dense class="textfield-cuadrado" type="text" v-model="mat" label="MATERNO" @input="mat = mat.toUpperCase()" @keyup.enter="buscarEstudiante()">
            </v-text-field>
        </v-col>
        <v-col cols="12" md="2">
            <v-text-field outlined dense class="textfield-cuadrado" type="text" v-model="nomest" label="NOMBRES" @input="nomest = nomest.toUpperCase()" @keyup.enter="buscarEstudiante()">
            </v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="d-flex justify-end">
            <v-btn rounded color="#002245" class="ma-2 white--text" :loading="buscando" @click="buscarEstudiante()">
                BUSCAR
                <v-icon right dark>
                    mdi-account-search
                </v-icon>
            </v-btn>
        </v-col>

        <v-col v-if="sinResultados" cols="12">
            <base-estado-vacio
              icono="mdi-account-search-outline"
              titulo="No se encontraron estudiantes con esos datos"
              descripcion="Revise el unicódigo o los apellidos y vuelva a buscar."
              color-icono="#9fb1c4"
            />
        </v-col>
        <v-col v-else cols="12">
            <base-matrix-table
              class="tabla-modal-designacion"
              :columnas-izquierda="columnasEstudiante"
              :columnas-derecha="columnasDerechaEstudiante"
              :filas="estudiantesPagina"
              clave-fila="unicod"
              @click:fila="seleccionarEst"
            >
              <!-- Además de poder clickear la fila entera, este botón deja seleccionar
                   el estudiante explícitamente. `@click.stop` evita que el click dispare
                   TAMBIÉN el `@click:fila` de la tabla (que ya llama a `seleccionarEst`
                   con la misma fila). -->
              <template #[`celda.accion`]="{ fila }">
                <v-btn
                  icon
                  small
                  color="secondary"
                  title="SELECCIONAR"
                  @click.stop="seleccionarEst(fila)"
                >
                  <v-icon small>mdi-check-circle-outline</v-icon>
                </v-btn>
              </template>
            </base-matrix-table>
        </v-col>
        <v-col cols="12" class="d-flex justify-end align-center" v-if="totalPaginas > 1">
            <span class="mr-3 grey--text text--darken-1">PÁGINA {{ paginaActual }} DE {{ totalPaginas }}</span>
            <v-btn icon :disabled="paginaActual === 1" @click="paginaActual--">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn icon :disabled="paginaActual === totalPaginas" @click="paginaActual++">
                <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
        </v-col>
    </v-row>
    </v-card-text>
</v-card>
</template>

<script>

import BaseMatrixTable from '../BaseMatrixTable.vue';
import BaseEstadoVacio from '../BaseEstadoVacio.vue';
import { apiFactory } from '@/api/apiFactory.js';

const useEstudianteBusquedaApi = apiFactory('useEstudianteBusquedaApi');

export default {
    components: {
        BaseMatrixTable,
        BaseEstadoVacio,
    },
    props: {
        title: {
            type: String,
            default: 'BUSCADOR DE ESTUDIANTES'
        },
        idSede: {
            type: [Number, String],
            default: null
        }
    },
    emits: ['seleccionarEstudiante', 'close'],

    computed : {
        user() {
            return this.$store.getters.user;
        },
        sedeEfectiva() {
            return this.idSede != null && this.idSede !== '' ? this.idSede : this.user.id_sede;
        },
        /** Filtro en vivo por PATERNO, igual al que hacia :search="pat" en la v-data-table anterior. */
        estudiantesFiltrados() {
            if (!this.pat) return this.datosEstudiante;
            const termino = this.pat.toString().toUpperCase();
            return this.datosEstudiante.filter((fila) =>
                Object.values(fila).some((valor) => valor != null && valor.toString().toUpperCase().includes(termino))
            );
        },
        totalPaginas() {
            return Math.max(1, Math.ceil(this.estudiantesFiltrados.length / this.porPagina));
        },
        sinResultados() {
            return this.buscado && !this.buscando && !this.datosEstudiante.length;
        },
        estudiantesPagina() {
            const inicio = (this.paginaActual - 1) * this.porPagina;
            return this.estudiantesFiltrados.slice(inicio, inicio + this.porPagina);
        },
    },

    watch: {
        estudiantesFiltrados() {
            this.paginaActual = 1;
        },
    },

    data() {
        return {
            uniest: '',
            pat: '',
            mat: '',
            nomest: '',
            porPagina: 15,
            paginaActual: 1,
            columnasEstudiante: [
                { valor: "unicod", texto: "UNICODIGO" },
                { valor: "matr", texto: "MATRICULA" },
                { valor: "pat", texto: "PATERNO" },
                { valor: "mat", texto: "MATERNO" },
                { valor: "nom", texto: "NOMBRES" },
                { valor: "carre", texto: "CARRERA" },
            ],
            columnasDerechaEstudiante: [
                { valor: "accion", texto: "" },
            ],
            datosEstudiante: [],
            buscando: false,
            // Hubo al menos una búsqueda: sin eso, una tabla vacía no es "sin resultados".
            buscado: false,
        }
    },

    methods: {
        /*
         * Antes: llamaba a `me.limpiarApell()`, que no existe en este
         * componente (quedó de cuando la búsqueda vivía en layout/Buscador.vue);
         * el TypeError lo tragaba un `.catch` vacío, así que "sin resultados" y
         * los errores de red no se mostraban nunca. Los campos NO se limpian
         * después de buscar: es lo que ya pasaba en la práctica (el error
         * cortaba antes de limpiar) y deja a la vista qué se buscó.
         */
        buscarEstudiante() {
            if (this.uniest != "") {
                this.listarEstudianteUnicod();
            } else {
                this.listarEstudiante();
            }
        },

        async listarEstudiante() {
            await this.ejecutarBusqueda(() => useEstudianteBusquedaApi.buscarPorApellidos({
                paterno: this.pat,
                materno: this.mat,
                nombres: this.nomest,
                id_sede: this.sedeEfectiva,
            }));
        },

        async listarEstudianteUnicod() {
            await this.ejecutarBusqueda(() => useEstudianteBusquedaApi.buscarPorUnicodigo({
                unicodigo: this.uniest,
                id_sede: this.sedeEfectiva,
            }));
        },

        async ejecutarBusqueda(pedir) {
            this.buscando = true;
            try {
                const response = await pedir();
                this.datosEstudiante = (response.data && response.data.resultado) || [];
                this.buscado = true;
            } catch (error) {
                this.datosEstudiante = [];
                // Endpoint legacy: el texto del error viene en `.message`.
                const detalle = error.response && error.response.data && error.response.data.message;
                this.$store.dispatch('openSnackbar', {
                    mensaje: detalle
                        ? `NO SE PUDO BUSCAR EL ESTUDIANTE: ${detalle}`
                        : 'NO SE PUDO BUSCAR EL ESTUDIANTE. REVISE SU CONEXIÓN E INTENTE NUEVAMENTE',
                    tipo: 'ERROR',
                });
            } finally {
                this.buscando = false;
            }
        },

        seleccionarEst(item) {
            this.$emit('seleccionarEstudiante', item);
            this.$store.dispatch('closeTopModal');
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>

<style scoped>
.buscador-modal {
  max-width: 92vw;
}
.textfield-cuadrado >>> .v-input__control {
  border-radius: 4px !important;
}
.textfield-cuadrado >>> fieldset {
  border-color: #002245 !important;
  border-width: 1.5px !important;
}
.textfield-cuadrado >>> input {
  text-align: left;
  color: #002245 !important;
  -webkit-text-fill-color: #002245;
  font-weight: 500;
}
</style>
